// src/app/permissionsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  menuPermissions: {}, // { subName: { visible: bool, actions: { Save: bool, Find: bool, Edit: bool, Delete: bool } } }
};

export const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setMenuPermissions: (state, action) => {
      state.menuPermissions = action.payload;
    },
    clearMenuPermissions: (state) => {
      state.menuPermissions = initialState.menuPermissions;
    },
  },
});

export const { setMenuPermissions, clearMenuPermissions } = permissionsSlice.actions;

// Selectors (to read state)
export const selectMenuPermissions = (state) => state.permissions.menuPermissions;

export default permissionsSlice.reducer;